import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import config from 'Cloud/config';

import { destroyUser, setIsLoading, setNewUser, setUser, setUserData, setUserState } from './user.actions';
import { IState, SetIsLoadingAction } from './user.types';

const userConfig = config.get('user');

const initialState: IState = {
    isLoaded: !!userConfig,
    isLoading: false,
    hasError: false,
    data: userConfig,
    isNewUser: false,
};

export const userReducer = createReducer(initialState, {
    [setUser.type]: (state, action: PayloadAction<any>) => {
        state.data = action.payload;
    },
    [destroyUser.type]: () => initialState,
    [setNewUser.type]: (state) => {
        state.isNewUser = true;
    },
    [setUserData.type]: (state, action: PayloadAction<any>) => {
        state.data = action.payload;
        state.isLoaded = true;
    },
    [setIsLoading.type]: (state, action: PayloadAction<SetIsLoadingAction>) => {
        state.isLoading = action.payload.value;
    },
    [setUserState.type]: (state, action: PayloadAction<IState>) => {
        state = action.payload;
    },
});
